class DeviceLogFilter {
    networkDeviceLabel: null;
    insertData: null;
    className: null;
    logType: null;
    message: null;
    getResult = () => {
        return {
            networkDevice: this.networkDeviceLabel,
            insertData: this.insertData,
            className: this.className,
            logType: this.logType,
            message: this.message
        }
    }
}
export default DeviceLogFilter;
